import { render, staticRenderFns } from "./PageSection.vue?vue&type=template&id=102f497e&"
import script from "./PageSection.vue?vue&type=script&lang=js&"
export * from "./PageSection.vue?vue&type=script&lang=js&"
import style0 from "./PageSection.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports